<app-template-number
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [min]="min"
  [required]="required"
  [regex]="regex"
  [commas]="commas"
  [label]="label"
/>
